import { TwoColumnLayout } from 'layouts';
import { Skeleton } from 'ui';

const OtherMemberProfileSkeleton = () => (
  <>
    <Skeleton paragraph={{ rows: 8 }} title={false} />
    <TwoColumnLayout
      left={
        <>
          <Skeleton paragraph={{ rows: 12 }} title={false} />
          <Skeleton paragraph={{ rows: 12 }} title={false} />
        </>
      }
      leftOptions={{ widthMode: 'small' }}
      right={
        <>
          <Skeleton paragraph={{ rows: 6 }} title={false} />
          <Skeleton paragraph={{ rows: 6 }} title={false} />
          <Skeleton paragraph={{ rows: 6 }} title={false} />
        </>
      }
    />
  </>
);

export default OtherMemberProfileSkeleton;
